import { type RawApplicationContext } from 'browser/app';

import { type IApplicationContext, type IApplicationContextCustom } from 'shared/types/applicationContext';

export function createContext(rawApplicationContext: RawApplicationContext): IApplicationContext {
  return {
    ...rawApplicationContext,
    custom: rawApplicationContext.config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
  };
}
